/** Constants for localStorage keys used in the application. */
const SENTINELA_WEB_ESTABLISHMENT = 'sentinela::web::establishment'

/**
 * Storage object to manage establishment data
 * It provides methods to get, set, and remove the current establishment from localStorage.
 */
export const EstablishmentStorage = {
  currentEstablishment: {
    get: () => {
      try {
        const value = localStorage.getItem(SENTINELA_WEB_ESTABLISHMENT)
        return value ? value : null
      } catch {
        return null
      }
    },
    /** `establishment_id` of the stored (JSON) establishment, or null when absent or invalid */
    getId: (): string | null => {
      try {
        const raw = localStorage.getItem(SENTINELA_WEB_ESTABLISHMENT)
        if (!raw) return null
        const parsed: unknown = JSON.parse(raw)
        if (
          typeof parsed === 'object' &&
          parsed !== null &&
          'establishment_id' in parsed &&
          typeof parsed.establishment_id === 'string' &&
          parsed.establishment_id
        ) {
          return parsed.establishment_id
        }
        return null
      } catch {
        return null
      }
    },
    set: (establishment: string) =>
      localStorage.setItem(SENTINELA_WEB_ESTABLISHMENT, establishment),
    remove: () => localStorage.removeItem(SENTINELA_WEB_ESTABLISHMENT)
  }
}

export default EstablishmentStorage
